import { GeneralErrorTranslation } from '@/assets/locales/generalError/generalError.translation.en.ts';

export const generalErrorTranslation: GeneralErrorTranslation = {
  forbidden: {
    message: 'Nie masz uprawnień do dostępu do tej strony lub Twoja sesja wygasła.',
    subMessage:
      'Jeśli uważasz, że powinieneś mieć uprawnienia, poproś swojego kierownika lub przełożonego o przyznanie Ci dostępu.',
  },
  goBack: 'Powrót',
  logIn: 'Zaloguj się',
  noSession: {
    message: 'Nie jesteś zalogowany',
    primaryAction: 'Zaloguj się',
    statusLabel: 'Status sesji',
    subMessage: 'Zaloguj się ponownie, aby kontynuować pracę w jAIn.',
  },
  notAuthorized: {
    message: 'Brak uprawnień',
    primaryAction: 'Powrót',
    statusLabel: 'Status dostępu',
    subMessage:
      'Jeżeli uważasz, że powinieneś mieć dostęp do aplikacji, skontaktuj się z administratorem.',
  },
  notFound: {
    message: 'Strona nie istnieje!',
  },
  serviceUnavailable: {
    message: 'Nie udało się połączyć',
    primaryAction: 'Spróbuj ponownie',
    statusLabel: 'Gateway error',
    subMessage: 'Spróbuj ponownie za chwilę. Jeśli problem się powtarza, skontaktuj się z nami:',
  },
  title: 'Ups! Coś poszło nie tak',
  waitingForApproval: {
    message: 'Twoje konto oczekuje na zatwierdzenie',
    subMessage: 'Powiadomimy Cię, gdy zostanie zatwierdzone.',
  },
};
